const ButtonLoader = () => {
  return (
    <center>
      <div className="border-secondry h-6 w-6 animate-spin rounded-full  border-4 border-solid border-t-transparent"></div>
    </center>
  );
};

export default ButtonLoader;
